import { useEffect, useState } from 'react';
import { getStaticContent } from '../../services/commonServices';

function TermsAndConditionsWeb() {
  const [staticContent, setStaticContent] = useState('');

  const getList = async () => {
    const { data } = await getStaticContent();
    setStaticContent(data?.[0]?.termsAndConditions || '');
  };

  useEffect(() => {
    getList();
  }, []);

  return (
    <div className='p-2'>
      <div dangerouslySetInnerHTML={{ __html: staticContent }} />
    </div>
  );
}

export default TermsAndConditionsWeb;

